import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { authentication } from '../../services/Authentication';
import { config } from './Constants';
import helpers from '../../Function';
import moment from 'moment';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery"
import HeaderTab from "./Header";

class DetailCase extends Component {
    constructor(props) {
        super(props);
        const { name, user_id, jwt, user_permission } = authentication.currentUserValue;
        this.state = {
            jwt: jwt,
            user_permission: user_permission,
            username: name,
            userid: user_id,
            service_number: '-',
            first_name: '-',
            last_name: '-',
            owner_first_name: '-',
            owner_last_name: '-',
            phone_come: '-',
            member_phone: '-',
            project_name: '-',
            home_number: '-',
            project_status: '-',
            warranty: '-',
            category_name: '-',
            category_id: '',
            server_type_id: '5a627dab3fc2394c4f824e94',
            title: '-',
            contact: '-',
            service_status: '-',
            detail: '-',
            coordinate: [],
            coor_detail: '',
            department_type: '',
            department: [],
            office_id: '5a627dab3fc2394c4f824e94',
            office_name: '',
            office_email: '',
            status: '',
            modalIsOpen: false,
            modalIsOpenCancel: false,
            modalIsOpenDelete: false,
            save_value: 'save',
            sla_start_date: '',
            sla_end_date: '',
            sla_val: '',
            fromList: [],
            detail1: '',
            detail2: '',
            detail3: '',
            detail4: '',
            detail5: '',
            detail6: '',
            detail7: '',
            detail8: '',
            detail9: '',
            detail10: '',
            subscriber1: '',
            subscriber2: '',
            subscriber3: '',
            subscriber4: '',
            subscriber5: '',
            subscriber6: '',
            subscriber7: '',
            subscriber8: '',
            subscriber9: '',
            subscriber10: '',
            operator1: '',
            operator2: '',
            operator3: '',
            operator4: '',
            operator5: '',
            operator6: '',
            operator7: '',
            operator8: '',
            operator9: '',
            operator10: '',
            note1: '',
            note2: '',
            note3: '',
            note4: '',
            note5: '',
            note6: '',
            note7: '',
            note8: '',
            note9: '',
            note10: '',
            serviceStatus1: '',
            serviceStatus2: '',
            serviceStatus3: '',
            serviceStatus4: '',
            serviceStatus5: '',
            serviceStatus6: '',
            serviceStatus7: '',
            serviceStatus8: '',
            serviceStatus9: '',
            serviceStatus10: '',
            serviceDate1: '',
            serviceDate2: '',
            serviceDate3: '',
            serviceDate4: '',
            serviceDate5: '',
            serviceDate6: '',
            serviceDate7: '',
            serviceDate8: '',
            serviceDate9: '',
            serviceDate10: '',
            successDate1: '',
            successDate2: '',
            successDate3: '',
            successDate4: '',
            successDate5: '',
            successDate6: '',
            successDate7: '',
            successDate8: '',
            successDate9: '',
            successDate10: '',
            editDate1: '',
            editDate2: '',
            editDate3: '',
            editDate4: '',
            editDate5: '',
            editDate6: '',
            editDate7: '',
            editDate8: '',
            editDate9: '',
            editDate10: '',
            service_group: '',
            service_id: "",
            page: "",
            detail_list: [],
            service_type_all: [{ value: '', display: 'เลือกเรื่องย่อย' }],
            matches: window.matchMedia("(min-width: 768px)").matches
        }

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.change = this.change.bind(this);
        this.submitCoordinate = this.submitCoordinate.bind(this);

        this.closeModalCancel = this.closeModalCancel.bind(this);
        this.openModalCancel = this.openModalCancel.bind(this);
        this.cancelCoordinate = this.cancelCoordinate.bind(this);

        this.closeModalDelete = this.closeModalDelete.bind(this);
        this.DeleteTransaction = this.DeleteTransaction.bind(this);
        this.openModalDelete = this.openModalDelete.bind(this);

    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
        const handler = e => this.setState({ matches: e.matches });
        window.matchMedia("(min-width: 768px)").addListener(handler);

        this.setState({
            service_id: this.props.location.state.detail.id,
            page: this.props.location.state.detail.page
        })

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        for (var i = 1; i <= 10; i++) {
            this.state.fromList.push({
                row: i
                , col1: "detail" + i
                , col2: "subscriber" + i
                , col3: "operator" + i
                , col4: "serviceDate" + i
                , col5: "successDate" + i
                , col6: "editDate" + i
                , col7: "note" + i
                , col8: "serviceStatus" + i
                , col9: "service_type_id" + i
                , col10: "service_type_name" + i
            });
        }


        fetch(config.url.API_URL + '/coordinate/' + this.props.location.state.detail.id, requestOptions)
            .then(res => res.json())
            .then(data => {
                let FromApi = data.data.map(datas => {
                    //var dcreated = new Date();
                    return {
                        date: moment(datas.created).format('DD/MM/YYYY H:mm') + ' น.',
                        coordinate: datas.coordinate_name,
                        detail: datas.detail,
                    }
                });

                this.setState({
                    coordinate: [].concat(FromApi)
                });
            });

        fetch(config.url.API_URL + '/service_complaints/' + this.props.location.state.detail.id, requestOptions)
            .then(res => res.json())
            .then(data => {
                //console.log("==========================="+data.data[0].service_types[0].department[0].department_type)
                if (data.data.length > 0) {
                    this.setState({
                        service_number: data.data[0].service_number,
                        first_name: data.data[0].member_first_name,
                        last_name: data.data[0].member_last_name,
                        owner_first_name: data.data[0].owner_first_name,
                        owner_last_name: data.data[0].owner_last_name,
                        phone_come: data.data[0].income_phone,
                        member_phone: data.data[0].member_phone,
                        project_name: (Array.isArray(data.data[0].project_homes) && data.data[0].project_homes.length ? data.data[0].project_homes[0].name_th : ''),
                        home_number: data.data[0].home_number,
                        project_status: helpers.getProjectStatus(data.data[0].project_status),
                        warranty: moment(data.data[0].expired_insurance).format('DD/MM/YYYY'),
                        category_name: (Array.isArray(data.data[0].service_categorys) && data.data[0].service_categorys.length ?
                            data.data[0].service_categorys[0].name_th : ''),
                        service_group: (Array.isArray(data.data[0].service_groups) && data.data[0].service_groups.length ?
                            data.data[0].service_groups[0].name_th : ''),
                        category_id: (Array.isArray(data.data[0].service_categorys) && data.data[0].service_categorys.length ?
                            data.data[0].service_categorys[0]._id : ''),
                        server_type_id: (Array.isArray(data.data[0].service_types) && data.data[0].service_types.length ?
                            data.data[0].service_types[0]._id : ''),
                        title: (Array.isArray(data.data[0].service_types) && data.data[0].service_types.length ?
                            data.data[0].service_types[0].name_th : ''),
                        contact: helpers.getContactChannel(data.data[0].contact_chanel),
                        service_status: helpers.getServiceStatus2(data.data[0].service_status),
                        status: data.data[0].service_status,
                        department_type: (Array.isArray(data.data[0].service_types) && data.data[0].service_types.length ?
                            (Array.isArray(data.data[0].service_types[0].department) && data.data[0].service_types[0].department.length ?
                                data.data[0].service_types[0].department[0].department_type : '')
                            : ''),
                        detail: data.data[0].detail,
                        sla_val: (Array.isArray(data.data[0].service_types) && data.data[0].service_types.length ?
                            data.data[0].service_types[0].sla : 0),
                        sla_start_date: (data.data[0].sla_start_date ? moment(data.data[0].sla_start_date).format('DD/MM/YYYY H:mm น.') : ''),
                        sla_end_date: (data.data[0].sla_end_date ? moment(data.data[0].sla_end_date).format('DD/MM/YYYY H:mm น.') : ''),
                        detail_list: data.data[0].detail_list
                    });


                    if (this.state.server_type_id == "5e2feeced5fbcf576287f461" || this.state.server_type_id == "5e2ff41a3c9fc61de581e24f" || this.state.server_type_id == "5ed7ad78e89147747e46a78a" || this.state.server_type_id == "5ed7adcbe89147747e46a78b") {
                        $("#detail_list").show();
                    } else {
                        $("#detail_list").hide();
                    }

                    console.log(data.data[0].detail_list)
                    if (data.data[0].detail_list.length > 0) {
                        data.data[0].detail_list.map((datas, i) => {

                            this.setState({
                                ["service_type_id" + (i + 1)]: datas.service_type_id,
                                ["service_type_name" + (i + 1)]: datas.service_type_name,
                                ['detail' + (i + 1)]: datas.detail,
                                ['subscriber' + (i + 1)]: datas.subscriber,
                                ['operator' + (i + 1)]: datas.operator,
                                ['serviceDate' + (i + 1)]: (datas.serviceDate ? new Date(datas.serviceDate) : null),
                                ['successDate' + (i + 1)]: (datas.successDate ? new Date(datas.successDate) : null),
                                ['editDate' + (i + 1)]: (datas.editDate ? new Date(datas.editDate) : null),
                                ['note' + (i + 1)]: datas.note,
                                ['serviceStatus' + (i + 1)]: datas.serviceStatus,
                            })
                        });

                        fetch(config.url.API_URL + '/service_types/?categoryid='
                            + this.state.category_id + '&sortnameth=1&activestatus=1', requestOptions)
                            .then(res => res.json())
                            .then(data => {
                                // store user details and jwt token in local storage to keep user logged in between page refreshes
                                //alert(data.status);
                                if (data.data.length > 0) {
                                    let FromApi = data.data.map(datas => {
                                        return { value: `${datas._id}`, display: datas.name_th, emailto: datas.emailto, emailcc: datas.emailcc, sla: datas.sla, multi: datas.multi }
                                    });

                                    this.setState({
                                        service_type_all: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                                    });
                                } else {
                                    fetch(config.url.API_URL + '/juristic_types/?main_id='
                                        + this.state.category_id + '&sortnameth=1&activestatus=1', requestOptions)
                                        .then(res => res.json())
                                        .then(data => {
                                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                                            //alert(data.status);
                                            if (data.data.length > 0) {
                                                let FromApi = data.data.map(datas => {
                                                    return { value: datas._id, display: datas.name_th, emailto: datas.emailto_y, emailcc: datas.emailcc_y, sla: datas.sla, multi: datas.multi }
                                                });

                                                this.setState({
                                                    service_type_all: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                                                });
                                            }
                                        });
                                }
                            });
                    }
                    var typeset = ""
                    if (Array.isArray(data.data[0].service_types) && data.data[0].service_types.length &&
                        Array.isArray(data.data[0].service_types[0].department) && data.data[0].service_types[0].department.length) {
                        data.data[0].service_types[0].department.map(datas => {
                            if (typeset == "") {
                                typeset = "typeset[]=" + datas.department_type;
                            } else {
                                typeset += "&typeset[]=" + datas.department_type;
                            }
                        });
                    }

                    fetch(config.url.API_URL + '/users/?' + typeset, requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            //alert(data.status);
                            let FromApi = data.data.map(datas => {
                                return { value: datas._id, email: datas.email, display: datas.first_name + ' ' + datas.last_name }
                            });
                            this.setState({
                                department: [{ value: '', email: '', display: 'เลือกเจ้าหน้าที่' }].concat(FromApi)
                            });

                        });
                } else {
                    fetch(config.url.API_URL + '/juristics/' + this.props.location.state.detail.id, requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            //console.log("==========================="+data.data[0].service_types[0].department[0].department_type)
                            if (data.data.length > 0) {
                                this.setState({
                                    service_number: data.data[0].service_number,
                                    first_name: data.data[0].member_first_name,
                                    last_name: data.data[0].member_last_name,
                                    owner_first_name: data.data[0].owner_first_name,
                                    owner_last_name: data.data[0].owner_last_name,
                                    phone_come: data.data[0].income_phone,
                                    member_phone: data.data[0].member_phone,
                                    project_name: (Array.isArray(data.data[0].project_homes) && data.data[0].project_homes.length ? data.data[0].project_homes[0].name_th : ''),
                                    home_number: data.data[0].home_number,
                                    project_status: helpers.getProjectStatus(data.data[0].project_status),
                                    warranty: moment(data.data[0].expired_insurance).format('DD/MM/YYYY'),
                                    category_name: (Array.isArray(data.data[0].juristic_categorys) && data.data[0].juristic_categorys.length ?
                                        data.data[0].juristic_categorys[0].name_th : ''),
                                    service_group: (Array.isArray(data.data[0].service_groups) && data.data[0].service_groups.length ?
                                        data.data[0].service_groups[0].name_th : ''),
                                    category_id: (Array.isArray(data.data[0].juristic_categorys) && data.data[0].juristic_categorys.length ?
                                        data.data[0].juristic_categorys[0]._id : ''),
                                    server_type_id: (Array.isArray(data.data[0].juristic_types) && data.data[0].juristic_types.length ?
                                        data.data[0].juristic_types[0]._id : ''),
                                    title: (Array.isArray(data.data[0].juristic_types) && data.data[0].juristic_types.length ?
                                        data.data[0].juristic_types[0].name_th : ''),
                                    contact: helpers.getContactChannel(data.data[0].contact_chanel),
                                    service_status: helpers.getServiceStatus2(data.data[0].service_status),
                                    status: data.data[0].service_status,
                                    department_type: (Array.isArray(data.data[0].service_types) && data.data[0].service_types.length ?
                                        (Array.isArray(data.data[0].service_types[0].department) && data.data[0].service_types[0].department.length ?
                                            data.data[0].service_types[0].department[0].department_type : '')
                                        : ''),
                                    detail: data.data[0].detail,
                                    sla_val: (Array.isArray(data.data[0].service_types) && data.data[0].service_types.length ?
                                        data.data[0].service_types[0].sla : 0),
                                    sla_start_date: (data.data[0].sla_start_date ? moment(data.data[0].sla_start_date).format('DD/MM/YYYY H:mm น.') : ''),
                                    sla_end_date: (data.data[0].sla_end_date ? moment(data.data[0].sla_end_date).format('DD/MM/YYYY H:mm น.') : ''),
                                    detail_list: data.data[0].detail_list
                                });


                                if (this.state.server_type_id == "5e2feeced5fbcf576287f461" || this.state.server_type_id == "5e2ff41a3c9fc61de581e24f" || this.state.server_type_id == "5ed7ad78e89147747e46a78a" || this.state.server_type_id == "5ed7adcbe89147747e46a78b") {
                                    $("#detail_list").show();
                                } else {
                                    $("#detail_list").hide();
                                }

                                if (data.data[0].detail_list.length > 0) {
                                    data.data[0].detail_list.map((datas, i) => {
                                        this.setState({
                                            ["service_type_id" + (i + 1)]: datas.service_type_id,
                                            ["service_type_name" + (i + 1)]: datas.service_type_name,
                                            ['detail' + (i + 1)]: datas.detail,
                                            ['subscriber' + (i + 1)]: datas.subscriber,
                                            ['operator' + (i + 1)]: datas.operator,
                                            ['serviceDate' + (i + 1)]: (datas.serviceDate ? new Date(datas.serviceDate) : null),
                                            ['successDate' + (i + 1)]: (datas.successDate ? new Date(datas.successDate) : null),
                                            ['editDate' + (i + 1)]: (datas.editDate ? new Date(datas.editDate) : null),
                                            ['note' + (i + 1)]: datas.note,
                                            ['serviceStatus' + (i + 1)]: datas.serviceStatus,
                                        })
                                    });
                                }

                                fetch(config.url.API_URL + '/service_types/?categoryid='
                                    + this.state.category_id + '&sortnameth=1&activestatus=1', requestOptions)
                                    .then(res => res.json())
                                    .then(data => {
                                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                                        //alert(data.status);
                                        if (data.data.length > 0) {
                                            let FromApi = data.data.map(datas => {
                                                return { value: `${datas._id}`, display: datas.name_th, emailto: datas.emailto, emailcc: datas.emailcc, sla: datas.sla, multi: datas.multi }
                                            });

                                            this.setState({
                                                service_type_all: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                                            });
                                        } else {
                                            fetch(config.url.API_URL + '/juristic_types/?main_id='
                                                + this.state.category_id + '&sortnameth=1&activestatus=1', requestOptions)
                                                .then(res => res.json())
                                                .then(data => {
                                                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                                                    //alert(data.status);
                                                    if (data.data.length > 0) {
                                                        let FromApi = data.data.map(datas => {
                                                            return { value: datas._id, display: datas.name_th, emailto: datas.emailto_y, emailcc: datas.emailcc_y, sla: datas.sla, multi: datas.multi }
                                                        });

                                                        this.setState({
                                                            service_type_all: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                                                        });
                                                    }
                                                });
                                        }
                                    });
                                var typeset = ""
                                if (Array.isArray(data.data[0].service_types) && data.data[0].service_types.length &&
                                    Array.isArray(data.data[0].service_types[0].department) && data.data[0].service_types[0].department.length) {
                                    data.data[0].service_types[0].department.map(datas => {
                                        if (typeset == "") {
                                            typeset = "typeset[]=" + datas.department_type;
                                        } else {
                                            typeset += "&typeset[]=" + datas.department_type;
                                        }
                                    });
                                }

                                fetch(config.url.API_URL + '/users/?' + typeset, requestOptions)
                                    .then(res => res.json())
                                    .then(data => {
                                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                                        //alert(data.status);
                                        let FromApi = data.data.map(datas => {
                                            return { value: datas._id, email: datas.email, display: datas.first_name + ' ' + datas.last_name }
                                        });
                                        this.setState({
                                            department: [{ value: '', email: '', display: 'เลือกเจ้าหน้าที่' }].concat(FromApi)
                                        });
                                    });
                            } else {

                            }
                        });
                }
            });

        const script = document.createElement("script");
        script.src = "/js/detailcase.js";
        script.async = true;
        document.body.appendChild(script);
    }

    change(e) {
        console.log(e.target.name)
        this.setState({
            [e.target.name]: e.target.value
        });

        if (e.target.name == "office_id") {
            var index = e.target.selectedIndex;
            var optionElement = e.target.childNodes[index]
            var option = optionElement.getAttribute('email');

            this.setState({
                office_email: option
            });
        }

    }

    changeDate_serviceDate1 = date => {
        this.setState({
            serviceDate1: date
        });
    }

    changeDate_serviceDate2 = date => {
        this.setState({
            serviceDate2: date
        });
    }

    changeDate_serviceDate3 = date => {
        this.setState({
            serviceDate3: date
        });
    }

    changeDate_serviceDate4 = date => {
        this.setState({
            serviceDate4: date
        });
    }

    changeDate_serviceDate5 = date => {
        this.setState({
            serviceDate5: date
        });
    }

    changeDate_serviceDate6 = date => {
        this.setState({
            serviceDate6: date
        });
    }

    changeDate_serviceDate7 = date => {
        this.setState({
            serviceDate7: date
        });
    }

    changeDate_serviceDate8 = date => {
        this.setState({
            serviceDate8: date
        });
    }

    changeDate_serviceDate9 = date => {
        this.setState({
            serviceDate9: date
        });
    }

    changeDate_serviceDate10 = date => {
        this.setState({
            serviceDate10: date
        });
    }

    changeDate_successDate1 = date => {
        this.setState({
            successDate1: date
        });
    }

    changeDate_successDate2 = date => {
        this.setState({
            successDate2: date
        });
    }

    changeDate_successDate3 = date => {
        this.setState({
            successDate3: date
        });
    }

    changeDate_successDate4 = date => {
        this.setState({
            successDate4: date
        });
    }

    changeDate_successDate5 = date => {
        this.setState({
            successDate5: date
        });
    }

    changeDate_successDate5 = date => {
        this.setState({
            successDate5: date
        });
    }

    changeDate_successDate6 = date => {
        this.setState({
            successDate6: date
        });
    }

    changeDate_successDate7 = date => {
        this.setState({
            successDate7: date
        });
    }

    changeDate_successDate8 = date => {
        this.setState({
            successDate8: date
        });
    }

    changeDate_successDate9 = date => {
        this.setState({
            successDate9: date
        });
    }

    changeDate_successDate10 = date => {
        this.setState({
            successDate10: date
        });
    }

    changeDate_editDate1 = date => {
        this.setState({
            editDate1: date
        });
    }

    changeDate_editDate2 = date => {
        this.setState({
            editDate2: date
        });
    }

    changeDate_editDate3 = date => {
        this.setState({
            editDate3: date
        });
    }

    changeDate_editDate4 = date => {
        this.setState({
            editDate4: date
        });
    }

    changeDate_editDate5 = date => {
        this.setState({
            editDate5: date
        });
    }

    changeDate_editDate6 = date => {
        this.setState({
            editDate6: date
        });
    }

    changeDate_editDate7 = date => {
        this.setState({
            editDate7: date
        });
    }

    changeDate_editDate8 = date => {
        this.setState({
            editDate8: date
        });
    }

    changeDate_editDate9 = date => {
        this.setState({
            editDate9: date
        });
    }

    changeDate_editDate10 = date => {
        this.setState({
            editDate10: date
        });
    }

    //"successDate"+i
    //"editDate"+i

    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }



    //////////////START dialog Submit/////////////////
    submitCoordinate(e) {
        e.preventDefault();

        const resultoffice = this.state.department.find(({ value }) => value === this.state.office_id);
        console.log("==========this.state.server_type_id=========" + this.state.server_type_id)
        let list = [];


        for (var i = 1; i <= this.state.detail_list.length; i++) {
            list.push({
                service_type_id: this.state["service_type_id" + i],
                service_type_name: this.state["service_type_name" + i],
                detail: this.state["detail" + i],
                subscriber: this.state["subscriber" + i],
                operator: this.state["operator" + i],
                serviceDate: this.state["serviceDate" + i],
                successDate: this.state["successDate" + i],
                editDate: this.state["editDate" + i],
                note: this.state["note" + i],
                serviceStatus: this.state["serviceStatus" + i],
            })
        }
        //console.log(jwt);

        if (this.state.save_value == "save") {
            if (this.state.coor_detail == "") {
                const requestOptions = {
                    method: 'PUT',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                    body: JSON.stringify({
                        sendmail: true,
                        detail_list: list,
                        service_status: this.state.status,
                        old_service_status: this.state.status
                    }),
                };
                fetch(config.url.API_URL + '/service_complaints/' + this.state.service_id, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        //console.log(JSON.stringify(list))
                        //window.location.reload();
                    });
            } else {
                const requestOptions = {
                    method: 'PUT',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                    body: JSON.stringify({
                        sendmail: true,
                        detail_list: list,
                        service_status: this.state.status,
                        old_service_status: this.state.status
                    }),
                };
                fetch(config.url.API_URL + '/service_complaints/' + this.state.service_id, requestOptions)
                    .then(res => res.json())
                    .then(data => {

                        const requestOptions = {
                            method: 'POST',
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': this.state.jwt,
                            },
                            body: JSON.stringify({
                                coordinate_name: this.state.username,
                                coordinate_id: this.state.userid,
                                office_email: this.state.office_email,
                                office_name: (resultoffice === undefined ? '' : resultoffice.display),
                                office_id: this.state.office_id,
                                detail: this.state.coor_detail,
                                createname: this.state.username,
                                createid: this.state.userid,
                                service_complaint_id: this.state.service_id,
                                title: this.state.title,
                                memeber_name: this.state.first_name + ' ' + this.state.last_name,
                                member_phone: this.state.member_phone,
                                home_number: this.state.home_number,
                                category_name: this.state.category_name,
                                project_name: this.state.project_name,
                                content: this.state.detail,
                            }),
                        };

                        fetch(config.url.API_URL + '/coordinate', requestOptions)
                            .then(res => res.json())
                            .then(data => {
                                //window.location.reload();
                            });
                    });
            }
        } else if (this.state.save_value == "delete") {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    service_status: 'cancel',
                    detail_list: list,
                    old_service_status: this.state.status
                }),
            };

            fetch(config.url.API_URL + '/service_complaints/' + this.state.service_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    const requestOptions = {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': this.state.jwt,
                        },
                        body: JSON.stringify({
                            coordinate_name: this.state.username,
                            coordinate_id: this.state.userid,
                            office_email: this.state.office_email,
                            office_name: (resultoffice === undefined ? '' : resultoffice.display),
                            office_id: this.state.office_id,
                            detail: this.state.coor_detail,
                            createname: this.state.username,
                            createid: this.state.userid,
                            service_complaint_id: this.state.service_id,
                            title: this.state.title,
                            memeber_name: this.state.first_name + ' ' + this.state.last_name,
                            member_phone: this.state.member_phone,
                            home_number: this.state.home_number,
                            category_name: this.state.category_name,
                            project_name: this.state.project_name,
                            content: this.state.detail,
                        }),
                    };

                    fetch(config.url.API_URL + '/coordinate', requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            //window.location.reload();
                            //history.push('/');
                        });
                });
        } else if (this.state.save_value == "coordinated") {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    service_status: 'doing',
                    detail_list: list,
                    old_service_status: this.state.status
                }),
            };

            fetch(config.url.API_URL + '/service_complaints/' + this.state.service_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    ///////add coordinate
                    const requestOptions = {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': this.state.jwt,
                        },
                        body: JSON.stringify({
                            coordinate_name: this.state.username,
                            coordinate_id: this.state.userid,
                            office_email: this.state.office_email,
                            office_name: (resultoffice === undefined ? '' : resultoffice.display),
                            office_id: this.state.office_id,
                            detail: this.state.coor_detail,
                            createname: this.state.username,
                            createid: this.state.userid,
                            service_complaint_id: this.state.service_id,
                            title: this.state.title,
                            memeber_name: this.state.first_name + ' ' + this.state.last_name,
                            member_phone: this.state.member_phone,
                            home_number: this.state.home_number,
                            category_name: this.state.category_name,
                            project_name: this.state.project_name,
                            content: this.state.detail,
                        }),
                    };

                    fetch(config.url.API_URL + '/coordinate', requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            //window.location.reload();
                            //history.push('/');
                        });
                    ///////add coordinate
                });
        } else if (this.state.save_value == "finish") {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    service_status: 'close',
                    detail_list: list,
                }),
            };

            fetch(config.url.API_URL + '/service_complaints/' + this.state.service_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    //window.location.reload();
                });
        }

    }

    showOption(option, val, display) {
        if (option == val) {
            return <option value={val} selected>{display}</option>
        } else {
            return <option value={val}>{display}</option>
        }
    }

    openModal(e) {
        e.preventDefault();

        this.setState({ modalIsOpen: true });
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }
    //////////////END dialog Submit/////////////////

    //////////////START dialog Cancel/////////////////
    closeModalCancel() {
        this.setState({ modalIsOpenCancel: false });
    }

    cancelCoordinate() {

        this.setState({
            coor_detail: ''
            , office_id: '5a627dab3fc2394c4f824e94'
            , office_name: ''
            , office_email: ''
        });
        document.getElementById("coordinate-form").reset();
        this.setState({ modalIsOpenCancel: false });
    }

    openModalCancel() {
        this.setState({ modalIsOpenCancel: true });
    }
    //////////////END dialog Cancel/////////////////

    //////////////START dialog Delete/////////////////
    closeModalDelete() {
        this.setState({ modalIsOpenDelete: false });
    }

    DeleteTransaction() {
        //console.log(jwt);

    }

    openModalDelete() {
        this.setState({ modalIsOpenDelete: true });
    }
    //////////////END dialog Cancel/////////////////

    render() {
        let elemSubmit;
        //if(this.state.status == "progress"){
        elemSubmit = <form id="coordinate-form">
            {this.state.matches && (<div>
                <div className="row mt-3">
                    <div className="col-2" />
                    <div className="cus-col-label-1"><span className="label">รายละเอียดการประสานงาน</span></div>
                    <div className="col-5">
                        <textarea className="col-12" rows={3} defaultValue={""} onChange={this.change} name="coor_detail" />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-2" />
                    <div className="cus-col-label-1"><span className="label">การบันทึก</span></div>
                    <div className="col-5">
                        <select className="form-custom" style={{ height: 45 }} onChange={this.change} name="save_value">
                            <option value="save" >บันทึกการประสานงาน</option>
                            <option value="coordinated" >กำลังดำเนินการ</option>
                            <option value="delete" >ยกเลิก</option>
                            <option value="finish" >จบงาน</option>
                        </select>
                    </div>
                </div>
                <div className="row mt-5 mb-3">
                    <div className="col-12 text-center">
                        {((this.state.user_permission[252].permission == 1 && this.state.page === "mycase") &&
                            <input type="button" className="btn-save" name="Save" onClick={this.openModal} defaultValue="บันทึก" />
                        )}

                        {((this.state.user_permission[252].permission == 1 && this.state.page === "mycase") &&
                            <input type="button" className="btn-cancel ml-3" name="Cancel" onClick={this.openModalCancel} defaultValue="เคลียร์" />
                        )}

                        {((this.state.user_permission[254].permission == 1 && this.state.page === "donecase") &&
                            <input type="button" className="btn-save" name="Save" onClick={this.openModal} defaultValue="บันทึก" />
                        )}

                        {((this.state.user_permission[254].permission == 1 && this.state.page === "donecase") &&
                            <input type="button" className="btn-cancel ml-3" name="Cancel" onClick={this.openModalCancel} defaultValue="เคลียร์" />
                        )}

                        {((this.state.user_permission[256].permission == 1 && this.state.page === "allcase") &&
                            <input type="button" className="btn-save" name="Save" onClick={this.openModal} defaultValue="บันทึก" />
                        )}

                        {((this.state.user_permission[256].permission == 1 && this.state.page === "allcase") &&
                            <input type="button" className="btn-cancel ml-3" name="Cancel" onClick={this.openModalCancel} defaultValue="เคลียร์" />
                        )}

                        {((this.state.user_permission[261].permission == 1 && this.state.page === "customerhistory" && (this.state.status != 'close' && this.state.status != 'cancel')) &&
                            <input type="button" className="btn-save" name="Save" onClick={this.openModal} defaultValue="บันทึก" />
                        )}

                        {((this.state.user_permission[261].permission == 1 && this.state.page === "customerhistory" && (this.state.status != 'close' && this.state.status != 'cancel')) &&
                            <input type="button" className="btn-cancel ml-3" name="Cancel" onClick={this.openModalCancel} defaultValue="เคลียร์" />
                        )}
                    </div>
                </div>
            </div>)}
            {!this.state.matches && (<div>
                <div className="row mb-3">
                    <div className="col-4">
                        <span className="label">รายละเอียดการประสานงาน</span>
                    </div>
                    <div className="col-8">
                        <textarea className="col-12" rows={3} defaultValue={""} onChange={this.change} name="coor_detail" />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-4">
                        <span className="label">การบันทึก</span>
                    </div>
                    <div className="col-8">
                        <select className="form-custom" style={{ height: 45 }} onChange={this.change} name="save_value">
                            <option value="save" >บันทึกการประสานงาน</option>
                            <option value="coordinated" >กำลังดำเนินการ</option>
                            <option value="delete" >ยกเลิก</option>
                            <option value="finish" >จบงาน</option>
                        </select>
                    </div>
                </div>
                <div className="row mb-12">
                    <div className="col-sm-5 text-center">
                        {((this.state.user_permission[252].permission == 1 && this.state.page === "mycase") &&
                            <button type="button" className="btn btn-outline-primary" name="Save" onClick={this.openModal}>บันทึก</button>
                        )}
&nbsp;&nbsp;
                        {((this.state.user_permission[252].permission == 1 && this.state.page === "mycase") &&
                            <button type="button" className="btn btn-outline-dark" name="Cancel" onClick={this.openModalCancel}>เคลียร์</button>
                        )}

                        {((this.state.user_permission[254].permission == 1 && this.state.page === "donecase") &&
                            <button type="button" className="btn btn-outline-primary" name="Save" onClick={this.openModal}>บันทึก</button>
                        )}
&nbsp;&nbsp;
                        {((this.state.user_permission[254].permission == 1 && this.state.page === "donecase") &&
                            <button type="button" className="btn btn-outline-dark" name="Cancel" onClick={this.openModalCancel}>เคลียร์</button>
                        )}

                        {((this.state.user_permission[256].permission == 1 && this.state.page === "allcase") &&
                            <button type="button" className="btn btn-outline-primary" name="Save" onClick={this.openModal}>บันทึก</button>
                        )}
&nbsp;&nbsp;
                        {((this.state.user_permission[256].permission == 1 && this.state.page === "allcase") &&
                            <button type="button" className="btn btn-outline-dark" name="Cancel" onClick={this.openModalCancel}>เคลียร์</button>
                        )}

                        {((this.state.user_permission[261].permission == 1 && this.state.page === "customerhistory" && (this.state.status != 'close' && this.state.status != 'cancel')) &&
                            <input type="button" className="btn-save" name="Save" onClick={this.openModal} defaultValue="บันทึก" />
                        )}
&nbsp;&nbsp;
                        {((this.state.user_permission[261].permission == 1 && this.state.page === "customerhistory" && (this.state.status != 'close' && this.state.status != 'cancel')) &&
                            <input type="button" className="btn-cancel ml-3" name="Cancel" onClick={this.openModalCancel} defaultValue="เคลียร์" />
                        )}
                    </div>
                </div>
            </div>)}
        </form>;
        let detail = ""
        if (this.state.detail) {
            detail = this.state.detail.split('\n').map((item, i) => {
                return <div>{item}<br /></div>;
            });
        }

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">เปิดใบงาน</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">เปิดใบงาน</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                <HeaderTab />
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                {/* .card-header */}
                                <div>
                                    {this.state.matches && (
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-1">
                                                    <div className="number text-center">
                                                        <div>เลขที่</div>
                                                        <h1>{this.state.service_number}</h1>
                                                    </div>
                                                </div>
                                                <div className="col-11 card-detail">
                                                    <div className="row mt-3">
                                                        <div className="col-12">
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">เจ้าบ้าน</span>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.owner_first_name}</div>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.owner_last_name}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">ผู้แจ้ง</span>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.first_name}</div>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.last_name}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">เบอร์โทรเข้า</span>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.phone_come}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">เบอร์ติดต่อ</span>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.member_phone}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">โครงการ</span>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="form-custom">{this.state.project_name}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">บ้านเลขที่</span>
                                                                        </div>
                                                                        <div className="cus-col-label-1">
                                                                            <div className="form-custom">{this.state.home_number}</div>
                                                                        </div>
                                                                        <div className="cus-col-label-05">
                                                                            <span className="label">สถานะ</span>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.project_status}</div>
                                                                        </div>
                                                                        <div className="cus-col-label-05">
                                                                            <span className="label">ประกัน</span>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.warranty}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 pl-3">
                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">หมวดเรื่อง</span>
                                                                        </div>
                                                                        <div className="cus-col-label-2">
                                                                            <div className="form-custom">{this.state.category_name}</div>
                                                                        </div>
                                                                        <div className="cus-col-label-05">
                                                                            <span className="label">กลุ่มหัวข้อ</span>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="form-custom">{this.state.service_group}</div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">เรื่องย่อ</span>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="form-custom">{this.state.title}</div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">SLA <span className="text-danger">{(this.state.sla_val && (this.state.sla_val > 24 ? (this.state.sla_val / 24) + ' วัน' : this.state.sla_val + ' ชั่วโมง'))}</span></span>
                                                                        </div>
                                                                        <div className="label" style={{ maxWidth: '63px' }}>เริ่มต้น : </div>
                                                                        <div className="col-2">
                                                                            <div className="form-custom">{this.state.sla_start_date}</div>
                                                                        </div>
                                                                        <div className="label" style={{ maxWidth: '63px' }}>สิ้นสุด : </div>
                                                                        <div className="col-2">
                                                                            <div className="form-custom">{this.state.sla_end_date}</div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row mb-3">
                                                                        <div className="cus-col-label-1">
                                                                            <span className="label">รายละเอียด</span>
                                                                        </div>
                                                                        <div className="col-8">
                                                                            <div className="form-custom">{detail}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="row" style={{ display: "none" }}>
                                                        <div className="col-12 pl-3">
                                                            <span className="label">รายการแจ้งซ่อม</span>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3" id="detail_list" style={{ display: "none" }}>
                                                        <div className="col-12 table-responsive">
                                                            <table className="table table-list10">
                                                                <thead className="thead-blue">
                                                                    <tr>
                                                                        <th width="30px">No</th>
                                                                        <th width="14%">รายการย่อย</th>
                                                                        <th>รายการซ่อม</th>
                                                                        <th width="10%">ผู้เซ็นต์รับ</th>
                                                                        <th width="10%">ผู้ดำเนินการ</th>
                                                                        <th width="9%">วันที่ช่างเข้า</th>
                                                                        <th width="9%">วันที่แล้วเสร็จ</th>
                                                                        <th width="9%">วันที่แก้ไขเพิ่มเติม</th>
                                                                        <th>หมายเหตุ</th>
                                                                        <th width="14%">สถานะการซ่อม</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    {this.state.fromList.map((data) => (
                                                                        <tr>
                                                                            <td>{data.row}</td>
                                                                            <td>
                                                                                <select className="form-custom" name={data.col9} onChange={this.change}>
                                                                                    {this.state.service_type_all.map((datas) => this.showOption(this.state[data.col9], datas.value, datas.display))}
                                                                                </select>
                                                                            </td>
                                                                            <td>
                                                                                <input type="text" className="form-custom" name={data.col1}
                                                                                    onChange={this.change} defaultValue={this.state[data.col1]} />
                                                                            </td>
                                                                            <td>
                                                                                <input type="text" className="form-custom" name={data.col2}
                                                                                    defaultValue={this.state[data.col2]} onChange={this.change} />
                                                                            </td>
                                                                            <td>
                                                                                <input type="text" className="form-custom" name={data.col3}
                                                                                    defaultValue={this.state[data.col3]} onChange={this.change} />
                                                                            </td>
                                                                            <td>
                                                                                <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col4]}
                                                                                    name={data.col4} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col4]} />
                                                                            </td>
                                                                            <td>
                                                                                <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col5]}
                                                                                    name={data.col5} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col5]} />
                                                                            </td>
                                                                            <td>
                                                                                <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col6]}
                                                                                    name={data.col6} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col6]} />
                                                                            </td>
                                                                            <td>
                                                                                <input type="text" className="form-custom" name={data.col7}
                                                                                    defaultValue={this.state[data.col7]} onChange={this.change} />
                                                                            </td>
                                                                            <td>
                                                                                <select className="form-custom" name={data.col8} onChange={this.change}>
                                                                                    <option value="">เลือกสถานะการซ่อม</option>
                                                                                    <option selected={this.state[data.col8] == "progress" && "selected"} value="progress">กำลังดำเนินการ</option>
                                                                                    <option selected={this.state[data.col8] == "finish" && "selected"} value="finish">จบงาน</option>
                                                                                    <option selected={this.state[data.col8] == "cancel" && "selected"} value="cancel">ยกเลิก</option>
                                                                                </select>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-12 table-responsive">
                                                            <table className="table">
                                                                <thead className="thead-blue">
                                                                    <tr>
                                                                        <th width="15%">วันที่ประสานงาน</th>
                                                                        <th width="15%">ผู้ประสานงาน</th>
                                                                        <th>รายละเอียดการประสานงาน</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {this.state.coordinate.map((data) => (
                                                                        <tr>
                                                                            <td>{data.date}</td>
                                                                            <td>{data.coordinate}</td>
                                                                            <td>{data.detail}</td>
                                                                        </tr>
                                                                    ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    {elemSubmit}
                                                </div>
                                            </div>
                                        </div>)}
                                    {!this.state.matches && (<div className="card-body">
                                        <div className="row">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div>เลขที่</div>
                                                    <h1>{this.state.service_number}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-2">
                                                <span className="label">เจ้าบ้าน<span className="text-danger"></span></span>
                                            </div>
                                            <div className="col-5">
                                                <div className="form-custom">{this.state.owner_first_name}</div>
                                            </div>
                                            <div className="col-5">
                                                <div className="form-custom">{this.state.owner_last_name}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-2">
                                                <span className="label">ผู้แจ้ง</span>
                                            </div>
                                            <div className="col-5">
                                                <div className="form-custom">{this.state.first_name}</div>
                                            </div>
                                            <div className="col-5">
                                                <div className="form-custom">{this.state.last_name}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">เบอร์โทรเข้า</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.phone_come}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">เบอร์ติดต่อ</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.member_phone}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">โครงการ</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.project_name}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">บ้านเลขที่</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.home_number}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">สถานะ</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.project_status}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">ประกัน</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.warranty}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">หมวดเรื่อง</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.category_name}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">กลุ่มหัวข้อ</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.service_group}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">เรื่องย่อ</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.title}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">SLA <span className="text-danger">{(this.state.sla_val && (this.state.sla_val > 24 ? (this.state.sla_val / 24) + ' วัน' : this.state.sla_val + ' ชั่วโมง'))}</span></span>
                                            </div>
                                            <div className="col-8">
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">เริ่มต้น</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.sla_start_date}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">สิ้นสุด</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{this.state.sla_end_date}</div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <span className="label">รายละเอียด</span>
                                            </div>
                                            <div className="col-8">
                                                <div className="form-custom">{detail}</div>
                                            </div>
                                        </div>
                                        <div className="row" style={{ display: "none" }}>
                                            <div className="col-12 pl-3">
                                                <span className="label">รายการแจ้งซ่อม</span>
                                            </div>
                                        </div>
                                        <div className="row mt-3" id="detail_list" style={{ display: "none" }}>
                                            <div className="col-12 table-responsive">
                                                <table className="table table-list10">
                                                    <thead className="thead-blue">
                                                        <tr>
                                                            <th width="30px">No</th>
                                                            <th width="14%">รายการย่อย</th>
                                                            <th>รายการซ่อม</th>
                                                            <th width="10%">ผู้เซ็นต์รับ</th>
                                                            <th width="10%">ผู้ดำเนินการ</th>
                                                            <th width="9%">วันที่ช่างเข้า</th>
                                                            <th width="9%">วันที่แล้วเสร็จ</th>
                                                            <th width="9%">วันที่แก้ไขเพิ่มเติม</th>
                                                            <th>หมายเหตุ</th>
                                                            <th width="14%">สถานะการซ่อม</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {this.state.fromList.map((data) => (
                                                            <tr>
                                                                <td>{data.row}</td>
                                                                <td>
                                                                    <select className="form-custom" name={data.col9} onChange={this.change}>
                                                                        {this.state.service_type_all.map((datas) => this.showOption(this.state[data.col9], datas.value, datas.display))}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-custom" name={data.col1}
                                                                        onChange={this.change} defaultValue={this.state[data.col1]} />
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-custom" name={data.col2}
                                                                        defaultValue={this.state[data.col2]} onChange={this.change} />
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-custom" name={data.col3}
                                                                        defaultValue={this.state[data.col3]} onChange={this.change} />
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col4]}
                                                                        name={data.col4} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col4]} />
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col5]}
                                                                        name={data.col5} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col5]} />
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col6]}
                                                                        name={data.col6} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col6]} />
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-custom" name={data.col7}
                                                                        defaultValue={this.state[data.col7]} onChange={this.change} />
                                                                </td>
                                                                <td>
                                                                    <select className="form-custom" name={data.col8} onChange={this.change}>
                                                                        <option value="">เลือกสถานะการซ่อม</option>
                                                                        <option selected={this.state[data.col8] == "progress" && "selected"} value="progress">กำลังดำเนินการ</option>
                                                                        <option selected={this.state[data.col8] == "finish" && "selected"} value="finish">จบงาน</option>
                                                                        <option selected={this.state[data.col8] == "cancel" && "selected"} value="cancel">ยกเลิก</option>
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <table className="table table-responsive">
                                                    <thead className="thead-blue">
                                                        <tr>
                                                            <th width="25%">วันที่ประสานงาน</th>
                                                            <th width="25%">ผู้ประสานงาน</th>
                                                            <th width="50%">รายละเอียดการประสานงาน</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.coordinate.map((data) => (
                                                            <tr>
                                                                <td>{data.date}</td>
                                                                <td>{data.coordinate}</td>
                                                                <td>{data.detail}</td>
                                                            </tr>
                                                        ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {elemSubmit}
                                    </div>)}
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                    <Modal show={this.state.modalIsOpen} onHide={this.closeModal}>
                        <ModalHeader>
                            <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            <h3>คุณต้องการบันทึกรายการนี้ใช่หรือไม่</h3>
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-danger" onClick={this.closeModal}>ยกเลิก</button>
                            <button className="btn btn-info" onClick={this.submitCoordinate}>บันทึก</button>
                        </ModalFooter>
                    </Modal>

                    <Modal show={this.state.modalIsOpenCancel} onHide={this.closeModalCancel}>
                        <ModalHeader>
                            <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            <h3>คุณต้องการยกเลิกรายการประสานงานรายการนี้ใช่หรือไม่</h3>
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-danger" onClick={this.closeModalCancel}>ยกเลิก</button>
                            <button className="btn btn-info" onClick={this.cancelCoordinate}>ตกลง</button>
                        </ModalFooter>
                    </Modal>

                    <Modal show={this.state.modalIsOpenDelete} onHide={this.closeModalDelete}>
                        <ModalHeader>
                            <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            <h3>คุณต้องการยกเลิกใบงานรายการนี้ใช่หรือไม่</h3>
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-default" onClick={this.closeModalDelete}>ยกเลิก</button>
                            <button className="btn btn-danger" onClick={this.DeleteTransaction}>ตกลง</button>
                        </ModalFooter>
                    </Modal>
                </section>
            </div>
        );
    }
}

export default withRouter(DetailCase);